var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSheetsExtension(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36364 2C5.61052 2 5 2.61052 5 3.36364V20.6364C5 21.3895 5.61052 22 6.36364 22H18.1818C18.9349 22 19.5455 21.3895 19.5455 20.6364V7.45455L14.0909 2H6.36364Z",
    fill: "#20A464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36364 22C5.61052 22 5 21.3895 5 20.6364V20.4091C5 21.1622 5.61052 21.7727 6.36364 21.7727H18.1818C18.9349 21.7727 19.5455 21.1622 19.5455 20.4091V20.6364C19.5455 21.3895 18.9349 22 18.1818 22H6.36364Z",
    fill: "#149456"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36364 2C5.61052 2 5 2.61052 5 3.36364V3.59091C5 2.83779 5.61052 2.22727 6.36364 2.22727H14.3182L14.0909 2H6.36364Z",
    fill: "#38AE74"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5454 12.1136V7.45455L18.7499 6.65909H14.9139C14.6101 6.65909 14.458 7.0263 14.6728 7.24106L19.5454 12.1136Z",
    fill: "url(#paint0_linear_196_5361)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0908 2L19.5454 7.45455H15.4545C14.7013 7.45455 14.0908 6.84402 14.0908 6.09091V2Z",
    fill: "#8ED1B1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9092 11.7727V18.3636H8.63647V11.7727H15.9092ZM11.8183 12.6818H9.54557V13.8182H11.8183V12.6818ZM12.7274 13.8182V12.6818H15.0001V13.8182H12.7274ZM11.8183 14.5H9.54557V15.6364H11.8183V14.5ZM12.7274 15.6364V14.5H15.0001V15.6364H12.7274ZM11.8183 16.3182H9.54557V17.4545H11.8183V16.3182ZM12.7274 17.4545V16.3182H15.0001V17.4545H12.7274Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_5361",
    x1: 17.0588,
    y1: 12.1136,
    x2: 17.0588,
    y2: 6.54546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#207E55"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetsExtension);
export default __webpack_public_path__ + "static/media/sheets-extension.4d7bcd60bc767b43d8d858f40d5bfe8f.svg";
export { ForwardRef as ReactComponent };